import {
  H_01,
  HERO_DEFAULTS,
  hideH01Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  CATALOG_HOME_LINK_TYPE,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
  OTHER_LINK_TYPE,
  URL_TYPE_OPTIONS,
} from "@stadium/shared/src/constants/stores/routes";

export const H01_PLASMIC_PROPS = {
  h01EyebrowText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_01].eyebrowText,
    description: "Small uppercase text above heading (H01 only)",
    hidden: hideH01Props,
  },
  h01Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_01].heading,
    description: "Main hero heading (H1) (H01 only)",
    hidden: hideH01Props,
  },
  h01Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_01].description,
    description: "Hero description text (H01 only)",
    hidden: hideH01Props,
  },
  h01CtaText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_01].ctaText,
    description: "Call-to-action button text (H01 only)",
    hidden: hideH01Props,
  },
  h01CtaLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    hidden: hideH01Props,
  },
  h01CtaOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open call-to-action button in new tab (H01 only)",
    hidden: hideH01Props,
  },
  h01CtaOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH01Props(props) ||
      (props.h01CtaLinkType !== OTHER_LINK_TYPE && props.h01CtaLinkType !== EXTERNAL_LINK_TYPE),
  },
  h01CtaCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH01Props(props) ||
      (props.h01CtaLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.h01CtaLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  h01Cta2Text: {
    type: "string",
    defaultValue: "",
    description: "Second CTA button text (H01 only). Leave empty to hide.",
    hidden: hideH01Props,
  },
  h01Cta2LinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    hidden: (props) => hideH01Props(props) || !props.h01Cta2Text,
  },
  h01Cta2OpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open second CTA button in new tab (H01 only)",
    hidden: (props) => hideH01Props(props) || !props.h01Cta2Text,
  },
  h01Cta2OtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH01Props(props) ||
      !props.h01Cta2Text ||
      (props.h01Cta2LinkType !== OTHER_LINK_TYPE && props.h01Cta2LinkType !== EXTERNAL_LINK_TYPE),
  },
  h01Cta2CategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH01Props(props) ||
      !props.h01Cta2Text ||
      (props.h01Cta2LinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.h01Cta2LinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  h01TabletImg: {
    type: "object",
    fields: {
      image: {
        type: "imageUrl",
      },
      height: {
        type: "string",
      },
    },
    defaultValue: { image: HERO_DEFAULTS[H_01].mobileImg, height: "27.125rem" },
    description: "Tablet hero image and height (H01 only)",
    hidden: hideH01Props,
  },
  h01DesktopImg: {
    type: "object",
    fields: {
      image: {
        type: "imageUrl",
      },
      height: {
        type: "string",
      },
    },
    defaultValue: { image: HERO_DEFAULTS[H_01].desktopImg, height: "32rem" },
    description: "Desktop hero image and height (H01 only)",
    hidden: hideH01Props,
  },
  h01HighResImg: {
    type: "object",
    fields: {
      image: {
        type: "imageUrl",
      },
      height: {
        type: "string",
      },
    },
    defaultValue: { image: HERO_DEFAULTS[H_01].desktopImg, height: "40rem" },
    description: "High resolution hero image and height for 1700px+ screens (H01 only)",
    hidden: hideH01Props,
  },
  h01MobileImg: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_01].mobileImg,
    description: "Mobile hero image (H01 only)",
    hidden: hideH01Props,
  },
  h01ImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_01].imageAlt,
    description: "Alt text for hero image (accessibility) (H01 only)",
    hidden: hideH01Props,
  },
  h01StandardMargin: {
    type: "boolean",
    defaultValue: false,
    description: "Use standard section margin instead of H01-specific margin (H01 only)",
    hidden: hideH01Props,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
